// extracted by mini-css-extract-plugin
export var active = "Sidebar-module--active--07818";
export var iconContainer = "Sidebar-module--iconContainer--a2358";
export var sidebar = "Sidebar-module--sidebar--2f93e";